import { render, staticRenderFns } from "./CatalogueCategories.vue?vue&type=template&id=75ec194e"
import script from "./CatalogueCategories.vue?vue&type=script&lang=js"
export * from "./CatalogueCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports